/* 88 Acres product page on Horizon (blocks pdp-head-88, pdp-purchase-88, pdp-freeship-88,
   pdp-trust-88, pdp-packs-88). Works with Horizon's own product form: the purchase block owns a
   hidden selling_plan input tied to the form via the `form` attribute; this script keeps it,
   the headline price and the free shipping bar in sync. Loaded with defer, safe to load twice. */
(function () {
  'use strict';
  if (window.__pdp88) return;
  window.__pdp88 = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var fmt = function (n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    };
    var value;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      default: value = fmt(cents, 2, ',', '.');
    }
    return match ? format.replace(match[0], value) : value;
  }

  function scope(el) {
    return el.closest('.shopify-section') || document;
  }
  function moneyFormat(sc) {
    var h = sc.querySelector('[data-pdp88-head]');
    return (h && h.getAttribute('data-money-format')) || '${{amount}}';
  }
  function productForm(sc) {
    return sc.querySelector('form[data-type="add-to-cart-form"]');
  }
  function formQty(sc) {
    var f = productForm(sc);
    var q = f && f.querySelector('input[name="quantity"]');
    return Math.max(1, parseInt(q && q.value, 10) || 1);
  }
  function formVariantId(sc) {
    var f = productForm(sc);
    var i = f && f.querySelector('input[name="id"]');
    return i ? parseInt(i.value, 10) : null;
  }

  /* Recharge's theme widget injects its own Subscribe & Save radios into every product form.
     The purchase block replaces it on this page, so remove the widget (it only adds a
     selling_plan field once someone picks its subscribe option). */
  function removeRecharge(sc) {
    var f = productForm(sc);
    if (!f) return;
    Array.prototype.forEach.call(f.querySelectorAll('.rc-container-wrapper, .rc_container_wrapper, [data-rc-widget]'), function (w) {
      w.parentNode && w.parentNode.removeChild(w);
    });
  }

  /* ---------- Purchase options ---------- */
  function unitPrice(sc) {
    var p = sc.querySelector('[data-pdp88-purchase]');
    if (!p) return null;
    var variants = [];
    try { variants = JSON.parse(p.querySelector('[data-pdp88-variants]').textContent); } catch (e) {}
    var vid = formVariantId(sc);
    var v = variants.filter(function (x) { return x.id === vid; })[0] || variants[0];
    if (!v) return null;
    var sub = p.querySelector('.pdp88-radio[value="subscribe"]');
    var plan = p.querySelector('[data-pdp88-plan]');
    var subPrice = plan && v.plans[plan.value] != null ? v.plans[plan.value] : null;
    return { v: v, isSub: !!(sub && sub.checked), sub: subPrice, unit: sub && sub.checked && subPrice != null ? subPrice : v.price };
  }

  function renderPurchase(sc) {
    var p = sc.querySelector('[data-pdp88-purchase]');
    if (!p) return;
    var fmt = moneyFormat(sc);
    var sub = p.querySelector('.pdp88-radio[value="subscribe"]');
    var plan = p.querySelector('[data-pdp88-plan]');
    var freq = p.querySelector('[data-pdp88-freq]');
    if (freq && plan) plan.value = freq.value;
    if (plan) plan.disabled = !(sub && sub.checked);
    Array.prototype.forEach.call(p.querySelectorAll('[data-pdp88-card]'), function (c) {
      c.classList.toggle('is-selected', !!c.querySelector('.pdp88-radio:checked'));
    });
    var st = unitPrice(sc);
    if (!st) return;
    var set = function (sel, cents) { var el = sc.querySelector(sel); if (el) el.textContent = formatMoney(cents, fmt); };
    if (st.sub != null) set('[data-pdp88-sub-price]', st.sub);
    set('[data-pdp88-once-price]', st.v.price);
    set('[data-pdp88-price]', st.unit);
    atcPrice(sc, st.unit);
    var was = sc.querySelector('[data-pdp88-was]');
    if (was) {
      if (st.unit < st.v.price) { was.hidden = false; was.textContent = formatMoney(st.v.price, fmt); }
      else if (st.v.compare > st.v.price) { was.hidden = false; was.textContent = formatMoney(st.v.compare, fmt); }
      else { was.hidden = true; }
    }
  }

  /* Line price on Horizon's Add to cart ("Add to cart · $19.34") and on the sticky bar */
  function atcPrice(sc, unit) {
    var fmt = moneyFormat(sc);
    var btn = sc.querySelector('.product-details .add-to-cart-button');
    if (btn) {
      var host = btn.querySelector('.add-to-cart-text__content') || btn.querySelector('.add-to-cart-text') || btn;
      var span = btn.querySelector('.pdp88-atc-price');
      if (!span) {
        span = document.createElement('span');
        span.className = 'pdp88-atc-price';
        var added = host === btn ? btn.querySelector('.add-to-cart__added') : null;
        if (added) btn.insertBefore(span, added); else host.appendChild(span);
      }
      span.textContent = btn.disabled ? '' : '· ' + formatMoney(unit * formQty(sc), fmt);
    }
    var sticky = sc.querySelector('.sticky-add-to-cart__price');
    if (sticky) sticky.textContent = formatMoney(unit, fmt);
  }

  /* Horizon's gallery thumbnails carry aria-selected on plain buttons (axe: aria-allowed-attr).
     Give them the tab roles that make aria-selected valid. */
  function fixThumbRoles(sc) {
    Array.prototype.forEach.call(sc.querySelectorAll('.slideshow-controls__thumbnails'), function (list) {
      if (list.getAttribute('role') !== 'tablist') list.setAttribute('role', 'tablist');
      Array.prototype.forEach.call(list.querySelectorAll('[aria-selected]'), function (b) {
        if (b.getAttribute('role') !== 'tab') b.setAttribute('role', 'tab');
      });
    });
    /* Same for the mobile dots (ol > li > button[aria-selected]) */
    Array.prototype.forEach.call(sc.querySelectorAll('.slideshow-controls__dots'), function (list) {
      if (list.getAttribute('role') !== 'tablist') list.setAttribute('role', 'tablist');
      Array.prototype.forEach.call(list.children, function (li) {
        if (li.tagName === 'LI' && li.getAttribute('role') !== 'presentation') li.setAttribute('role', 'presentation');
      });
      Array.prototype.forEach.call(list.querySelectorAll('[aria-selected]'), function (b) {
        if (b.getAttribute('role') !== 'tab') b.setAttribute('role', 'tab');
      });
    });
    /* Sticky Add to cart: Horizon hides its text on phones; keep a name either way */
    var sb = document.querySelector('.sticky-add-to-cart__button');
    if (sb && !sb.hasAttribute('aria-label')) sb.setAttribute('aria-label', 'Add to cart');
  }

  /* Highlights band scrolls sideways on phones: make it reachable by keyboard while it scrolls
     (axe scrollable-region-focusable). */
  function fixHlFocus() {
    Array.prototype.forEach.call(document.querySelectorAll('.pdp-hl__list'), function (l) {
      if (l.scrollWidth > l.clientWidth + 1) {
        if (l.getAttribute('tabindex') !== '0') l.setAttribute('tabindex', '0');
        if (!l.hasAttribute('aria-label')) l.setAttribute('aria-label', 'Highlights');
      } else if (l.getAttribute('tabindex') === '0') {
        l.removeAttribute('tabindex');
      }
    });
  }
  var hlTimer = null;
  window.addEventListener('resize', function () { clearTimeout(hlTimer); hlTimer = setTimeout(fixHlFocus, 150); });

  function initPurchase(p) {
    if (p.hasAttribute('data-pdp88-ready')) return;
    p.setAttribute('data-pdp88-ready', '');
    var sc = scope(p);
    var go = function () { renderPurchase(sc); updateShip(sc); };
    Array.prototype.forEach.call(p.querySelectorAll('.pdp88-radio'), function (r) { r.addEventListener('change', go); });
    var freq = p.querySelector('[data-pdp88-freq]');
    if (freq) freq.addEventListener('change', function () {
      var s = p.querySelector('.pdp88-radio[value="subscribe"]');
      if (s) s.checked = true;
      go();
    });
    Array.prototype.forEach.call(p.querySelectorAll('[data-pdp88-card]'), function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('select, label, a, button')) return;
        var r = card.querySelector('.pdp88-radio');
        if (r && !r.checked) { r.checked = true; go(); }
      });
    });
    removeRecharge(sc);
    var f = productForm(sc);
    if (f && 'MutationObserver' in window) {
      new MutationObserver(function () { removeRecharge(sc); }).observe(f, { childList: true, subtree: true });
    }
    go();
  }

  /* ---------- Pack cards (sample pack): set Horizon's quantity ---------- */
  function setFormQty(sc, n) {
    var f = productForm(sc);
    var q = f && f.querySelector('input[name="quantity"]');
    if (!q) return;
    var comp = q.closest('quantity-selector-component');
    if (comp && typeof comp.setValue === 'function') comp.setValue(String(n));
    else q.value = n;
    q.dispatchEvent(new Event('input', { bubbles: true }));
    q.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function initPacks(p) {
    if (p.hasAttribute('data-pdp88-ready')) return;
    p.setAttribute('data-pdp88-ready', '');
    var sc = scope(p);
    var sync = function () {
      var r = p.querySelector('[data-pdp88-pack]:checked');
      Array.prototype.forEach.call(p.querySelectorAll('[data-pdp88-card]'), function (c) {
        c.classList.toggle('is-selected', !!c.querySelector('[data-pdp88-pack]:checked'));
      });
      if (r) setFormQty(sc, parseInt(r.value, 10) || 1);
      updateShip(sc);
    };
    Array.prototype.forEach.call(p.querySelectorAll('[data-pdp88-pack]'), function (r) { r.addEventListener('change', sync); });
    Array.prototype.forEach.call(p.querySelectorAll('[data-pdp88-card]'), function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('label, a, button')) return;
        var r = card.querySelector('[data-pdp88-pack]');
        if (r && !r.checked) { r.checked = true; sync(); }
      });
    });
    sync();
  }

  /* ---------- Free shipping progress ---------- */
  var cartTotal = null;
  function updateShip(sc) {
    var box = sc.querySelector('[data-pdp88-ship]');
    if (!box) return;
    var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    var threshold = Math.round((parseFloat(box.getAttribute('data-threshold')) || 0) * rate);
    var st = unitPrice(sc);
    var unit = st ? st.unit : parseInt(box.getAttribute('data-unit'), 10) || 0;
    var btn = box.querySelector('[data-pdp88-ship-add]');
    if (cartTotal === null || !threshold || !unit || cartTotal >= threshold) { box.hidden = true; return; }
    var fmt = moneyFormat(sc);
    var qty = formQty(sc);
    var withSel = cartTotal + unit * qty;
    var left = threshold - withSel;
    var text = box.querySelector('[data-pdp88-ship-text]');
    if (left > 0) {
      text.textContent = (box.getAttribute('data-label-away') || '').replace('[amount]', formatMoney(left, fmt));
      var extra = Math.ceil((threshold - cartTotal) / unit) - qty;
      var show = extra > 0 && extra <= 5 && !sc.querySelector('[data-pdp88-packs]');
      btn.hidden = !show;
      if (show) {
        btn.textContent = (box.getAttribute('data-label-add') || '').replace('[count]', extra);
        btn.onclick = function () { setFormQty(sc, qty + extra); updateShip(sc); };
      }
    } else {
      text.textContent = box.getAttribute('data-label-ready') || '';
      btn.hidden = true;
    }
    box.querySelector('[data-pdp88-ship-bar]').style.width = Math.min(100, Math.round(withSel / threshold * 100)) + '%';
    box.hidden = false;
  }
  function updateAllShip() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pdp88-ship]'), function (b) { updateShip(scope(b)); });
  }
  var cartTimer = null;
  function refreshCart() {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(function () {
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { cartTotal = c.total_price || 0; updateAllShip(); })
        .catch(function () {});
    }, 250);
  }

  /* ---------- Shipping & returns dialog ---------- */
  function initDialog(btn) {
    if (btn.hasAttribute('data-pdp88-ready')) return;
    btn.setAttribute('data-pdp88-ready', '');
    var dlg = document.getElementById(btn.getAttribute('aria-controls'));
    if (!dlg || typeof dlg.showModal !== 'function') return;
    btn.addEventListener('click', function () { dlg.showModal(); document.documentElement.classList.add('pdp88-lock'); });
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('pdp88-lock'); btn.focus(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    var c = dlg.querySelector('[data-pdp88-dialog-close]');
    if (c) c.addEventListener('click', function () { dlg.close(); });
  }

  /* Horizon's gallery scroller (slideshow-slides) scrolls sideways but can't take focus
     (axe scrollable-region-focusable, serious). Make it a labelled, focusable region so
     keyboard users can scroll it with the arrow keys. */
  function fixGalleryFocus(sc) {
    Array.prototype.forEach.call(sc.querySelectorAll('slideshow-slides'), function (s) {
      if (s.getAttribute('tabindex') === '0') return; /* Horizon renders tabindex="-1" */
      s.setAttribute('tabindex', '0');
      s.setAttribute('role', 'region');
      s.setAttribute('aria-label', 'Product photos');
    });
  }

  /* Mobile: show Horizon's sticky Add to cart bar from the first screen while the main
     Add to cart is still below the fold (Horizon only shows it after scrolling past).
     Horizon's own observer keeps handling the "scrolled past" case. */
  var earlyBound = false;
  function earlySticky() {
    if (earlyBound || !('IntersectionObserver' in window)) return;
    var bar = document.querySelector('.sticky-add-to-cart__bar');
    var main = document.querySelector('.product-details .buy-buttons-block');
    if (!bar || !main || !document.querySelector('[data-pdp88-head]')) return;
    earlyBound = true;
    var mq = window.matchMedia('(max-width: 749px)');
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      if (!e) return;
      var below = !e.isIntersecting && e.boundingClientRect.top > 0;
      if (below && mq.matches) {
        bar.dataset.stuck = 'true';
        bar.setAttribute('data-pdp88-early', '');
      } else if (bar.hasAttribute('data-pdp88-early')) {
        bar.removeAttribute('data-pdp88-early');
        if (e.isIntersecting) bar.dataset.stuck = 'false';
      }
    }).observe(main);
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pdp88-purchase]'), initPurchase);
    Array.prototype.forEach.call(document.querySelectorAll('[data-pdp88-packs]'), initPacks);
    Array.prototype.forEach.call(document.querySelectorAll('[data-pdp88-ship-open]'), initDialog);
    Array.prototype.forEach.call(document.querySelectorAll('[data-pdp88-head]'), function (h) { removeRecharge(scope(h)); fixThumbRoles(scope(h)); fixGalleryFocus(scope(h)); });
    updateAllShip();
    plainAtc();
    earlySticky();
    fixHlFocus();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  refreshCart();

  /* Horizon re-renders the product details on variant change and in the theme editor. */
  ['variant:update', 'shopify:section:load', 'shopify:block:select'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(initAll, 0); });
  });
  if ('MutationObserver' in window) {
    var t = null;
    var fresh = '[data-pdp88-purchase]:not([data-pdp88-ready]), [data-pdp88-packs]:not([data-pdp88-ready]), [data-pdp88-ship-open]:not([data-pdp88-ready])';
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { if (document.querySelector(fresh)) initAll(); }, 50);
    })
      .observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  }
  /* Products without Subscribe & Save: line price from the header's one-time price */
  function plainAtc() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pdp88-head]'), function (h) {
      var sc = scope(h);
      if (!sc.querySelector('[data-pdp88-purchase]')) atcPrice(sc, parseInt(h.getAttribute('data-price'), 10) || 0);
    });
  }
  function onQty() {
    updateAllShip();
    Array.prototype.forEach.call(document.querySelectorAll('[data-pdp88-purchase]'), function (p) { renderPurchase(scope(p)); });
    plainAtc();
  }
  document.addEventListener('quantity-selector:update', onQty);
  document.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') onQty(); });
  document.addEventListener('change', function (e) { if (e.target && e.target.name === 'quantity') onQty(); });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('quantity-selector-component button')) setTimeout(onQty, 0); });
  document.addEventListener('cart:update', refreshCart);
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (en) {
          if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(en.name)) refreshCart();
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
})();
